export const LIST = "mobile/contact/LIST";
export const UNREAD = "mobile/contact/UNREAD";

export const setList = (data) => ({
    type: LIST,
    payload: data
});

export const setUnread = (data) => ({
    type: UNREAD,
    payload: data
});
